export const CTA_EVENT_COLUMNS = [
  { key: "applyClicks", label: "Apply Clicks" },
  { key: "resultClicks", label: "Result Clicks" },
  { key: "admitCardClicks", label: "Admit Card Clicks" },
  { key: "notificationDownloads", label: "Notification Downloads" },
  { key: "officialWebsiteClicks", label: "Official Website Clicks" },
  { key: "answerKeyClicks", label: "Answer Key Clicks" },
  { key: "syllabusClicks", label: "Syllabus Clicks" },
];

export const PAGE_TYPE_OPTIONS = [
  { value: "", label: "All Page Types" },
  { value: "job_detail", label: "Job Detail" },
  { value: "result_detail", label: "Result Detail" },
  { value: "admit_card_detail", label: "Admit Card Detail" },
  { value: "exam_page", label: "Exam Page" },
  { value: "listing_page", label: "Listing Page" },
  { value: "other", label: "Other" },
];

export const EVENT_TYPE_OPTIONS = [
  { value: "", label: "All Event Types" },
  { value: "applyClicks", label: "Apply Clicks" },
  { value: "resultClicks", label: "Result Clicks" },
  { value: "admitCardClicks", label: "Admit Card Clicks" },
  { value: "notificationDownloads", label: "Notification Downloads" },
  { value: "officialWebsiteClicks", label: "Official Website Clicks" },
  { value: "answerKeyClicks", label: "Answer Key Clicks" },
  { value: "syllabusClicks", label: "Syllabus Clicks" },
];

export const formatAnalyticsNumber = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "0";
  return new Intl.NumberFormat("en-IN").format(parsed);
};

export const formatAnalyticsDate = (value) => {
  if (!value) return "NA";

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "NA";

  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(parsed);
};

export const csvEscape = (value) => {
  const text = String(value ?? "");
  if (/[",\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};
